export const WY_APPKEY = {
  PROD: '66629618cac2a664de4501c2',
  TEST: '6667ffb5cac2a664de472edc',
}

export const HD_APPKEY = {
  PROD: '66629c51940d5a4c49673ea7',
  TEST: '66680019940d5a4c4969645f',
}

export const OTHERS_APPKEY = {
  PROD: '6662a012940d5a4c49673fa8',
  TEST: '6668003a940d5a4c496964d0',
}

export const PKG_LIST = {
  ANDROID:
    'com.st.QSB,com.st.home,com.st.main,com.st.mine,com.st.order,com.st.technician,com.st.trend,com.st.publiclib',
  IOS: 'com.st.qsb',
}

export const IGNORE_ERROR = [
  'unhandledrejection',
  'Script error',
  'Network Error',
  'Failed to fetch',
  'Load failed',
  'Request aborted',
  'timeout of 0ms exceeded',
  'Unable to preload CSS',
  'The operation was aborted',
  'The operation is not supported',
  'Importing a module script failed',
  'The play() request was interrupted',
  'play() can only be initiated by a user gesture',
  'The element has no supported sources',
  'Failed to start the audio device',
  `ReferenceError: Can't find variable: WeakRef`,
  'requireCredential but empty token',
  'Error: createBuffer error',
  'The callback prior to sending a one-to-one chat message was triggered, and the App backend returned a response to forbid the message!',
  'The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission.',
  "Uncaught TypeError: Cannot destructure property 'scrollHeight' of 'i' as it is null.",
  "Uncaught TypeError: Cannot read properties of null (reading 'scrollHeight')",
  "Uncaught TypeError: Cannot read properties of undefined (reading 'resolve')",
  'Uncaught ReferenceError: WeixinJSBridge is not defined',
  "null is not an object (evaluating 'this.uplinkConnection.localMainAudioTrack.volume=e.audioLevel')",
  'Type error',
  "TypeError: null is not an object (evaluating 'grandParentNode.parentNode')",
  'wx is not defined',
  "undefined is not an object (evaluating 'this._view.getOptions')",
  'Network request failed',
  'Failed to load because no supported source was found.',
  'Failed to send the request',
  'Attempted to assign to readonly property.',
  'Request failed with status code 503',
  'enumerateDevices() failed.',
  "Cannot read properties of undefined (reading 'code')",
  "Cannot read property 'code' of undefined",
  "Cannot set properties of null (setting 'volume')",
  "Cannot read properties of undefined (reading 'pageParam')",
  "Cannot read properties of null (reading 'update')",
  "Cannot create property 'value' on string ''",
  "undefined is not an object (evaluating 'n.code')",
  "undefined is not an object (evaluating 't.code')",
  "undefined is not an object (evaluating 'e.code')",
  "undefined is not an object (evaluating 't.replace')",
  "undefined is not an object (evaluating 'R.value')",
  "undefined is not an object (evaluating 'a[c.value].pageParam')",
  'Right side of assignment cannot be destructured',
  'The object is in an invalid state.',
  'HTTP request failed with status error',
  "null is not an object (evaluating 'this.bY.Nz.putImageData')",
  "null is not an object (evaluating 'l.value.update')",
  "ReferenceError: Can't find variable: WebViewJavascriptBridge",
  'WebKit encountered an internal error',
  'WeixinJSBridge is not defined',
  'upstream connect error or disconnect/reset before headers. reset reason: remote reset',
  'cancelled',
  "Unexpected token '发', \"发送了位置信息\" is not valid JSON",
  'Params validate failed.',
  "ReferenceError: Can't find variable: EmptyRanges",
  'u.getSenders(...)[0].getStats is not a function',
  "null is not an object (evaluating 'this.uplinkConnection.localMainAudioTrack.volume=e.audioLevel')",
  "Type error",
  "TypeError: null is not an object (evaluating 'grandParentNode.parentNode')",
  '已取消',
  '请求超时',
  '请求参数错误',
  '请求过于频繁，请稍后再试',
  '当前请求时间过长，已中止，已发起新的请求，请稍候',
  '没有找到相应的会话，请检查传入参数',
  '无法连接服务器。',
  '网络连接已中断。',
  '只允许上传 jpg png jpeg gif bmp image webp 格式的图片',
  '文件上传失败',
  '会话不存在',
]

export const ORDER_PROCESS_PAGE = {
  HOMEMODULE: '首页-推荐套餐',
  TECHNICIANLIST: '技师列表',
  TECHNICIANLISTMAP: '地图模式',
  PRODUCTLIST: '套餐列表',
  TECHNICIANDETAIL: '技师详情',
  PRODUCTDETAIL: '套餐详情',
  CHOOSETECHNICIAN: '选择技师',
  BOOKINGORDER: '预约下单',
  MYORDERS: '订单列表',
  ORDERDETAIL: '订单详情',
  MYMODULEHOMEPAGE: '我的页面',
  MYMODULEHOME: '我的-精选套餐',
  MYCOUPON: '我的优惠券',
  MYATTENTION: '我的关注',
  FOOTPRINT: '我的足迹',
  MYEVALUATION: '我的评价',
  TRENDSDETAIL: '作品详情',
  IMMESSAGE: '私聊',
  DAILYSPECIAL: '超级满减',
  GROWTHCENTER: '成长中心',
  MYGROWTH: '我的成长值'
}
